import * as actions from "./actionTypes";
import * as config from "config";
import ObjectToQueryString from 'utils/ObjectToQueryString';

export function getWithdrawalsMetrics(params) {
    return {
        type: config.apiRequestStart,
        payload: {
        url: config.apiGetAllWithdrawalsMetrics + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_WITHDRAWALS_METRICS_START,
            onSuccess: actions.GET_WITHDRAWALS_METRICS,
            onError: actions.GET_WITHDRAWALS_METRICS_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getPrevMonthWithdrawalsData(params) {
    return {
        type: config.apiRequestStart,
        payload: {
        url: config.apiGetAllWithdrawalsMetrics + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_PREV_MONTH_WITHDRAWALS_START,
            onSuccess: actions.GET_PREV_MONTH_WITHDRAWALS_DONE,
            onError: actions.GET_PREV_MONTH_WITHDRAWALS_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getWithdrawals(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllWithdrawals + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_ALL_WITHDRAWALS_START,
            onSuccess: actions.GET_ALL_WITHDRAWALS,
            onError: actions.GET_ALL_WITHDRAWALS_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function downloadWithdrawals(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllWithdrawals + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.DOWNLOAD_GET_ALL_WITHDRAWALS_START,
            onSuccess: actions.DOWNLOAD_GET_ALL_WITHDRAWALS,
            onError: actions.DOWNLOAD_GET_ALL_WITHDRAWALS_FAILED,
        },
    }
}

export function approveWithdrawal(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiApproveWithdrawal + id,
            method: "post",
            data: {},
            onStart: actions.APPROVE_WITHDRAWAL_START,
            onSuccess: actions.APPROVE_WITHDRAWAL,
            onError: actions.APPROVE_WITHDRAWAL_FAILED,
        },
    }
}

export function rejectWithdrawal(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiRejectWithdrawal + id,
            method: "post",
            data: {},
            onStart: actions.REJECT_WITHDRAWAL_START,
            onSuccess: actions.REJECT_WITHDRAWAL,
            onError: actions.REJECT_WITHDRAWAL_FAILED,
        },
    }
}

export function resetReloadPage() {
    return {
        type: actions.RELOAD_PAGE_RESET,
        payload: {},
    }
}

export function getWithdrawalReport() {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetWithdrawalReport,
            method: "get",
            data: {},
            onStart: actions.GET_WITHDRAWAL_REPORT_START,
            onSuccess: actions.GET_WITHDRAWAL_REPORT,
            onError: actions.GET_WITHDRAWAL_REPORT_FAILED,
        },
    }
}
